/**
 * Size of an empty MpDoc snapshot in bytes (~80 today). Any save below this
 * threshold on a previously-non-empty doc implies the in-memory doc lost its
 * op log. Loro snapshots are monotonically non-decreasing through user actions
 * (deletes add tombstones, not subtract bytes), so this is a safe shrink-floor.
 *
 * Recalibration: run from mp/ —
 *   npx tsx -e "import { MpDoc } from './src/doc'; \
 *     console.log(MpDoc.empty({ changeMergeInterval: 300 }).exportSnapshot().state.byteLength)"
 * Set this constant to ~2.5x the measured value.
 */
export const EMPTY_DOC_BASELINE_BYTES = 200;
